import { render, staticRenderFns } from "./ConfirmarAsientos.vue?vue&type=template&id=48a3a7c7&scoped=true&"
import script from "./ConfirmarAsientos.vue?vue&type=script&lang=js&"
export * from "./ConfirmarAsientos.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmarAsientos.vue?vue&type=style&index=0&id=48a3a7c7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a3a7c7",
  null
  
)

export default component.exports